import React from 'react';
import { MapContainer, TileLayer, Polygon, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import ngeohash from 'ngeohash';

const getColorByCount = (count) => {
    if (count >= 20) return '#dc2626';
    if (count >= 10) return '#ea580c';
    if (count >= 5) return '#ca8a04';
    if (count >= 3) return '#16a34a';
    return '#2563eb';
};

// Tooltip styles
const tooltipStyle = {
    background: 'transparent',
    border: 'none',
    boxShadow: 'none',
    fontWeight: 'bold',
    fontSize: '14px',
    color: 'white',
    textShadow: '1px 1px 3px rgba(0,0,0,0.9)',
};

const TripLocationMap = ({ tripslocation, center = [25.6751, 94.1086], zoom = 13 }) => {

    // Function to get the center of a geohash for proper tooltip placement
    const getGeohashCenter = (geohash) => {
        try {
            const bbox = ngeohash.decode_bbox(geohash);
            const centerLat = (bbox[0] + bbox[2]) / 2;
            const centerLng = (bbox[1] + bbox[3]) / 2;
            return [centerLat, centerLng];
        } catch (error) {
            console.error('Error calculating geohash center:', error);
            return center;
        }
    };

    // Function to create polygon coordinates from geohash
    const createPolygonFromGeohash = (geohash) => {
        try {
            const bbox = ngeohash.decode_bbox(geohash);
            return [
                [bbox[0], bbox[1]], // SW
                [bbox[0], bbox[3]], // NW
                [bbox[2], bbox[3]], // NE
                [bbox[2], bbox[1]], // SE
                [bbox[0], bbox[1]]  // Close
            ];
        } catch (error) {
            console.error('Error creating polygon from geohash:', error);
            return null;
        }
    };

    if (!tripslocation || tripslocation.length === 0) {
        return (
            <div style={{ height: '100%', width: '100%' }}>
                <MapContainer center={center} zoom={zoom} style={{ height: '100%', width: '100%' }}>
                    <TileLayer
                        attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                </MapContainer>
            </div>
        );
    }

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <MapContainer center={center} zoom={zoom} style={{ height: '100%', width: '100%' }}>
                <TileLayer
                    attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />

                {tripslocation.map((location, index) => {
                    try {
                        const polygonCoords = createPolygonFromGeohash(location.geohash);

                        if (!polygonCoords) {
                            return null;
                        }

                        const centerCoords = getGeohashCenter(location.geohash);

                        return (
                            <Polygon
                                key={`${location.geohash}-${index}`}
                                positions={polygonCoords}
                                pathOptions={{
                                    color: 'black',
                                    fillColor: getColorByCount(location.count),
                                    fillOpacity: 0.6,
                                    weight: 2
                                }}
                            >
                                <Tooltip
                                    permanent
                                    direction="center"
                                    style={tooltipStyle}
                                    position={centerCoords} // Explicitly set tooltip position to center
                                >
                                    {location.count}
                                </Tooltip>
                            </Polygon>
                        );
                    } catch (error) {
                        console.error('Error processing geohash:', location.geohash, error);
                        return null;
                    }
                })}
            </MapContainer>
        </div>
    );
};

export default TripLocationMap;